export const MqttMixin = {
    data() {
        return {
            outService: false,
        };
    },
    methods: {
        isSubscribe(ref) {
            return this.$mqtt.isSubscribe(`ctl/${ref}/#`);
        },

        subscribe(ref) {
            this.$onInstance(`status_${ref}`, (mesage) => {
                this.$emit('message', mesage);
            });
            this.$emitInstance('suscribe', ref, `ctl/${ref}/#`);
        },

        unsubscribe(ref) {
            this.$emitInstance('unsubscribe', `ctl/${ref}/#`);
        },

        // subscribe: (installation, callback) => this._subscribeCommon(`ctl/${installation}/#`, callback),
        // unsubscribe: (installation, callback) => this._unsubscribeCommon(`ctl/${installation}/#`, callback),

        _generateInstruction(installation, device, comand, value) {
            return {
                sender: 'WEB',
                ctl: installation,
                app: this.$session.getClientId(),
                device: device,
                command: comand,
                value: value,
            };
        },

        syncInstallation(installation, callbackOK, callbackKO, callbackEND) {
            this.$api.addInstallation(
                installation,
                (data) => {
                    this.$onceOutInstance(
                        `reciveInstruction_${data.entity.orderId}`,
                        (event) => this._validateInstallation(installation, event, callbackOK, callbackKO, callbackEND),
                        (error) => {
                            if (callbackKO) callbackKO(error);
                            if (callbackEND) callbackEND();
                        },
                        null,
                        this.$config.OUTSERVICE_MILISECOND
                    );
                },
                (error) => {
                    if (callbackKO) callbackKO(error);
                    if (callbackEND) callbackEND();
                }
            );
        },

        _validateInstallation: function(installation, message, callbackOK, callbackKO, callbackEND) {
            message = JSON.parse(message.value.slice(0, -1));

            this.$api.updateInstallation(
                {
                    ...installation,
                    ...{
                        validated: 1,
                        version: message.v,
                        devices: message.t.map((term) => {
                            return {
                                installation_ref: this.installation.reference,
                                reference: term.rf,
                                name: term.n,
                                principal: term.pl,
                                floor: term.s,
                                cold: term.f,
                                hot: term.c,
                                fan: term.v,
                                timer: term.tz,
                                programming: term.hp,
                                temperature_max: term.tmx,
                                temperature_min: term.tmm,
                            };
                        }),
                    },
                },
                callbackOK,
                callbackKO,
                callbackEND
            );
        },

        _sendInstruction(installation, device, comand, value, callbackOK, callbackKO, callbackEND) {
            this.$emitInstance('sendInstruction');

            let fullCallbackOK = (data, status) => {
                if (callbackOK) callbackOK(data, status);
                this.$emitInstance('reciveInstruction', data, status);
            };
            let fullCallbackKO = (error) => {
                if (callbackKO) callbackKO(error);
                this.$emitInstance('errorInstruction', error);
            };
            let fullCallbackEND = () => {
                if (callbackEND) callbackEND();
                this.$emitInstance('endInstruction');
            };

            this.$api.instruction(
                this._generateInstruction(installation, device, comand, value),
                (data) =>
                    this.$onceOutInstance(
                        `reciveInstruction_${data.entity.value[0].orderId}`,
                        (data) => {
                            this.$onceOutInstance(
                                `reciveStatus_${data.ctl}`,
                                (status) => fullCallbackOK(data, status),
                                fullCallbackKO,
                                fullCallbackEND,
                                this.$config.OUTSERVICE_MILISECOND
                            );
                        },
                        (error) => {
                            fullCallbackKO(error);
                            fullCallbackEND();
                        },
                        null,
                        this.$config.OUTSERVICE_MILISECOND
                    ),
                (error) => {
                    fullCallbackKO(error);
                    fullCallbackEND();
                }
            );
        },

        getStatus(installation, callbackOK, callbackKO, callbackEND) {
            this.$uniqueSetTimeout(
                `mqttStatusControl${installation}`,
                () => this.$api.instruction(this._generateInstruction(installation, '', 'status', 'sync')),
                50
            );

            this.$onceOutInstance(
                `reciveStatus_${installation}`,
                callbackOK,
                callbackKO,
                callbackEND,
                this.$config.OUTSERVICE_MILISECOND
            );
        },

        setPower(installation, device, value, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'power', value, callbackOK, callbackKO, callbackEND);
        },

        setMode(installation, device, value, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'mode', value, callbackOK, callbackKO, callbackEND);
        },

        setTemp(installation, device, value, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'temp', `${value}`, callbackOK, callbackKO, callbackEND);
        },

        setFanspeed(installation, device, value, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'fanspeed', `${value}`, callbackOK, callbackKO, callbackEND);
        },

        setTemporizer(installation, device, value, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'temporizer', value, callbackOK, callbackKO, callbackEND);
        },

        stopInstallation(installation, device, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'stop', '1', callbackOK, callbackKO, callbackEND);
        },

        getPrograms(installation, device, callbackOK, callbackKO, callbackEND) {
            this._sendInstruction(installation, device, 'programs', '', callbackOK, callbackKO, callbackEND);
        },
    },
};
